<template>
  <section class="request-container pointer" @click.stop="showForm">
    <p>Mist u een product of onderwerp?</p>
    <button class="pill-button" @click.stop="showForm">
      laat het ons weten
    </button>
  </section>
</template>

<script>
import ProductRequest from '../dialogs/ProductRequest.vue'

export default {
  methods: {
    showForm() {
      this.$modal.show(ProductRequest, {}, { width: 380, height: 'auto' })
    }
  }
}
</script>

<style lang="scss" scoped>
p {
  color: var(--sub-color);
  font-weight: 500;
  padding-bottom: 10px;
}
.request-container {
  width: 191px;
  height: 274px;
  margin: 13px 9px;
  text-align: center;
  padding-top: 88px;
  border-radius: 24px;
  background-color: #f4f4f4;

  transition: box-shadow 0.5s;

  &:hover {
    box-shadow: 0 0 28px -14px rgba(0, 0, 0, 0.5);
  }
}
</style>
